
import BaseListagem from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterApplyTemplateOptions, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import ProdutoFornecedorService from "service/administracao/cadastro/produto/ProdutoFornecedorService";
import ProdutoService from "service/administracao/cadastro/produto/ProdutoService";
import { IdMatchModeOptions, ProdutoFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";

const produtoFornecedorService = new ProdutoFornecedorService();

export default function ProdutoFornecedorListagem() {

    const [familias, setFamilias] = useState<FamiliaProduto[]>([]);
    const [planosInspecao, setPlanosInspecao] = useState<PlanoInspecao[]>([]);
    const [fornecedores, setFornecedores] = useState<Pessoa[]>([]);
    const [produtos, setProdutos] = useState<Produto[]>([]);

    useEffect(() => {
        produtoFornecedorService.familias().then(lista => {
            setFamilias(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoFornecedorService.fornecedores().then(lista => {
            setFornecedores(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoFornecedorService.planosInspecao().then(lista => {
            setPlanosInspecao(lista);
        }).catch(err => {
            console.log(err);
        });
        produtoFornecedorService.produtos().then(lista => {
            setProdutos(lista);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    const dropdownFilterField = (options: ColumnFilterElementTemplateOptions, list: any[], optionValue?: string) => {
        return <Dropdown value={options.value} options={list} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel={"nome"} optionValue={optionValue ? optionValue : "codigo"} placeholder="Qualquer" className="p-column-filter" />
    }

    const defaultFilters: DataTableFilterMeta = {
        codigoProdutoFornecedor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        produto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        familiaProduto: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        fornecedor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        planoInspecao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }



    const filterApplyTemplate = (options: ColumnFilterApplyTemplateOptions) => {
        return <Button type="button" label="Aplicar" onClick={options.filterApplyCallback} ></Button>;
    };

    return (

        <BaseListagem ordenacao="fornecedor.nome,ASC" service={produtoFornecedorService} urlService="/produtoFornecedor" tituloPagina={'Produtos x Fornecedores'} defaultFilters={defaultFilters} showClearFilterButton nome="produtoFornecedor" >
            <Column field="produto.nome" header="Produto" style={{ width: '15em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="produto"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => <ProdutoFilterTemplate options={options} opcoes={produtos} />} />
            <Column field="produto.familiaProduto.nome" header="Família" style={{ width: '15em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="familiaProduto"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterField(options, familias)} />
            <Column field="fornecedor.nome" header="Fornecedor" style={{ width: '15em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="fornecedor"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterField(options, fornecedores, "id")} />
            <Column field="planoInspecao.descricao" header="Plano de inspeção" style={{ width: '15em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="planoInspecao"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterField(options, planosInspecao, "id")} />
            <Column field="codigoProdutoFornecedor" header="Código no Fornecedor" style={{ width: '10em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            

        </BaseListagem>
    )
}